import { Component, OnInit } from "@angular/core";
import { UserService } from "../../../services/userService";
import { ResponseError } from "../../../objects/common/responseError";
import { ForgotPasswordModel } from "../../../objects/users/forgotPasswordModel";

@Component({
    selector: 'forgot-password',
    templateUrl: './forgotPassword.component.html',
    moduleId: module.id.toString()
})
export class ForgotPasswordComponent implements OnInit {
    public model: ForgotPasswordModel;
    public processing: boolean;
    public success: boolean;
    public errors: Array<ResponseError> = [];

    constructor(
        private userService: UserService) { }

    ngOnInit(): void {
        this.model = new ForgotPasswordModel();
    }

    public forgotPassword(isValid: boolean): void {
        this.errors = [];

        if (!isValid)
            return;

        this.processing = true;
        this.userService.forgotPassword(this.model).then(response => {
            this.processing = false;
            this.success = true;
        }).catch(response => {
            this.processing = false;
            this.errors = this.errors.concat(response.Errors);
        });
    }
}


// WEBPACK FOOTER //
// ./app/components/auth/forgotPassword/forgotPassword.component.ts